import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import { Store } from '@ngxs/store';

import { Observable } from 'rxjs';

import { CognitoState } from '../state/store/cognito.state';

@Injectable({
  providedIn: 'root'
})
export class CognitoTokenInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.store.selectSnapshot(CognitoState.getIdToken);

    const clonedRequest = token
      ? request.clone({
          headers: request.headers.set('Authorization', 'Bearer ' + token) // Add your custom header here
        })
      : request;

    return next.handle(clonedRequest);
  }
}
